// A hack to make modulizr work with AMD (a la RequireJS), which is used by JavaScript code that is transpiled from
// TypeScript.
if (define && define.amd) {
    try {
        define("require", function () {
            return require;
        });
    }
    catch (e) {
        // Error: Dependency already defined require
        // We don't care about this error.
    }
}